import {shallowEqual, useSelector} from 'react-redux';
import {
  searchRoomDataSelector,
  searchRoomApiRequestSelector,
  previousBookingDataSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';

import DetailQuickBookCardUI from './PreviousBookingQuickBookCardUI';
import {userSelector} from '@stencil/user-reducer';
import BookingWidget from './BookingWidget';
import WhatOurGuestLikeLoader from '../../../../../stories/components/hotels/Loadingpage/WhatOurGuestLikeLoader/WhatOurGuestLikeLoader';

export default function DetailQuickBookandBookingWidgetWrapper({
  isSingleRoomWithSingleRatePlan = false,
  showPersuasion = false,
  hotelLevelPersuasion,
  handlOpenCalendar = () => {},
  altAcco = false,
  isDatePickRequired = false,
}) {
  const searchRoomApiRequest = useSelector(searchRoomApiRequestSelector);
  const roomsDataFromCg = useSelector(searchRoomDataSelector, shallowEqual);
  const previousBookingRoomData = useSelector(previousBookingDataSelector);

  const {isLoggedIn} = useSelector(userSelector);

  const filteredRooms =
    searchRoomApiRequest?.success && previousBookingRoomData?.length
      ? {
          exactRooms: previousBookingRoomData,
        }
      : [];
  const hideQuickBookWidget =
    !isLoggedIn || (isLoggedIn && (!filteredRooms || filteredRooms?.length == 0));

  if (searchRoomApiRequest?.loading) return <WhatOurGuestLikeLoader />;

  if (hideQuickBookWidget && isSingleRoomWithSingleRatePlan)
    return (
      <DetailQuickBookCardUI
        bookingwigitdata={roomsDataFromCg}
        isNoPreviousBooking={true}
        isDatePickRequired={isDatePickRequired}
        altAcco={altAcco}
        handlOpenCalendar={handlOpenCalendar}
      />
    );

  return (
    <>
      {hideQuickBookWidget ? (
        <BookingWidget
          showPersuasion={showPersuasion}
          hotelLevelPersuasion={hotelLevelPersuasion}
          isDatePickRequired={isDatePickRequired}
          handlOpenCalendar={handlOpenCalendar}
          altAcco={altAcco}
        />
      ) : (
        <DetailQuickBookCardUI
          bookingwigitdata={filteredRooms}
          isDatePickRequired={isDatePickRequired}
          altAcco={altAcco}
          handlOpenCalendar={handlOpenCalendar}
        />
      )}
    </>
  );
}
